// DON`T USE BASE COLORS IN CODE. THESE ARE JUST BASE PALETTE COLORS FOR THE COLOR ALIASES BELOW.
// VARIABLES FOR OKLCH COLORS
// const brandPrimaryHue = `293`;
// const brandSecondaryHue = `192`;
// const lightChroma = `0.01`;
// const semanticBackgroundLightness = `92%`;
// const semanticBackgroundChroma = `0.02`;
// const semanticForegroundLightness = `52%`;
// const semanticForegroundChroma = `0.15`;
// COULDNT USE OKLCH COLORS BECAUSE HTML2CANVAS PACKAGE DOESNT SUPPORT IT
// export const baseColors = {
//   // brand - primary
//   primary110: `oklch(34% 0.07 ${brandPrimaryHue})`,
//   primary100: `oklch(37% 0.07 ${brandPrimaryHue})`,
//   primary90: `oklch(42% 0.09 ${brandPrimaryHue})`,
//   primary10: `oklch(94% 0.01 ${brandPrimaryHue})`,
//   primary05: `oklch(97% 0.01 ${brandPrimaryHue})`,
//   // brand - secondary
//   secondary110: `oklch(88% 0.10 ${brandSecondaryHue})`,
//   secondary100: `oklch(93% 0.06 ${brandSecondaryHue})`,
//   secondary90: `oklch(95% 0.04 ${brandSecondaryHue})`,
//   // neutrals
//   black: `oklch(20% ${lightChroma} ${brandPrimaryHue})`,
//   neutral80: `oklch(36% ${lightChroma} ${brandPrimaryHue})`,
//   neutral60: `oklch(52% ${lightChroma} ${brandPrimaryHue})`,
//   neutral40: `oklch(68% ${lightChroma} ${brandPrimaryHue})`,
//   neutral20: `oklch(84% ${lightChroma} ${brandPrimaryHue})`,
//   neutral10: `oklch(92% ${lightChroma} ${brandPrimaryHue})`,
//   neutral06: `oklch(95.2% ${lightChroma} ${brandPrimaryHue})`,
//   neutral02: `oklch(98.4% ${lightChroma} ${brandPrimaryHue})`,
//   white: `oklch(100% 0 0)`,
//   // semantic
//   semanticErrorBackground: `oklch(${semanticBackgroundLightness} ${semanticBackgroundChroma} 9)`,
//   semanticErrorForeground: `oklch(${semanticForegroundLightness} ${semanticForegroundChroma} 9)`,
//   semanticSuccessBackground: `oklch(${semanticBackgroundLightness} ${semanticBackgroundChroma} 163)`,
//   semanticSuccessForeground: `oklch(${semanticForegroundLightness} ${semanticForegroundChroma} 163)`,
//   semanticInfoBackground: `oklch(${semanticBackgroundLightness} ${semanticBackgroundChroma} 246)`,
//   semanticInfoForeground: `oklch(${semanticForegroundLightness} ${semanticForegroundChroma} 246)`,
//   semanticWarningBackground: `oklch(${semanticBackgroundLightness} ${semanticBackgroundChroma} 73)`,
//   semanticWarningForeground: `oklch(${semanticForegroundLightness} ${semanticForegroundChroma} 73)`,
// };
export const baseColors = {
    // brand - primary
    primary110: `hsl(254 28% 27%)`,
    primary100: `hsl(254 28% 30%)`,
    primary90: `hsl(254 28% 37%)`,
    primary10: `hsl(254 28% 93%)`,
    primary05: `hsl(254 28% 97%)`,
    // brand - secondary
    secondary110: `hsl(177, 73%, 72%)`,
    secondary100: `hsl(177, 73%, 84%)`,
    secondary90: `hsl(177, 73%, 90%)`,
    // neutrals
    black: `hsl(276 9% 10%)`,
    neutral80: `hsl(276 9% 20%)`,
    neutral60: `hsl(276 9% 40%)`,
    neutral40: `hsl(276 9% 60%)`,
    neutral20: `hsl(276 9% 80%)`,
    neutral10: `hsl(276 9% 90%)`,
    neutral06: `hsl(276 9% 94%)`,
    neutral02: `hsl(276 9% 98%)`,
    white: `hsl(0 0% 100%)`,
    // semantic
    semanticErrorBackground: `hsl(352 80% 92%)`,
    semanticErrorForeground: `hsl(352 80% 55%)`,
    semanticSuccessBackground: `hsl(148 46% 92%)`,
    semanticSuccessForeground: `hsl(148 46% 33%)`,
    semanticInfoBackground: `hsl(209 50% 92%)`,
    semanticInfoForeground: `hsl(209 50% 56%)`,
    semanticWarningBackground: `hsl(33 87% 94%)`,
    semanticWarningForeground: `hsl(33 90% 65%)`,
};
// ONLY USE THESE COLOR ALIASES, NOTHING ABOVE THIS LINE.
export const colors = {
    // alerts / status
    errorBackground: baseColors.semanticErrorBackground,
    errorForeground: baseColors.semanticErrorForeground,
    successBackground: baseColors.semanticSuccessBackground,
    successForeground: baseColors.semanticSuccessForeground,
    infoBackground: baseColors.semanticInfoBackground,
    infoForeground: baseColors.semanticInfoForeground,
    warningBackground: baseColors.semanticWarningBackground,
    warningForeground: baseColors.semanticWarningForeground,
    // backgrounds
    backgroundBrand: baseColors.primary100,
    backgroundBrandLight: baseColors.primary10,
    backgroundBrandLightest: baseColors.primary05,
    backgroundBrandSecondary: baseColors.secondary100,
    backgroundInverted: baseColors.black,
    backgroundLight: baseColors.neutral06,
    backgroundLightest: baseColors.neutral02,
    backgroundPrimary: baseColors.white,
    // borders
    borderBrand: baseColors.primary90,
    borderDark: baseColors.neutral20,
    borderLight: baseColors.neutral10,
    // buttons - contained
    buttonBackgroundDefault: baseColors.primary100,
    buttonBackgroundHover: baseColors.primary90,
    buttonBackgroundActive: baseColors.primary110,
    buttonSecondaryBackgroundDefault: baseColors.secondary100,
    buttonSecondaryBackgroundHover: baseColors.secondary90,
    buttonSecondaryBackgroundActive: baseColors.secondary110,
    buttonBackgroundDisabled: baseColors.neutral10,
    buttonTextDefault: baseColors.primary100,
    buttonTextContainedDefault: baseColors.white,
    buttonTextDisabled: baseColors.neutral40,
    // buttons - outlined / text
    buttonOutlinedBackgroundDefault: `transparent`,
    buttonOutlinedBackgroundHover: baseColors.primary05,
    buttonOutlinedBackgroundActive: baseColors.primary05,
    buttonOutlinedBorderDisabled: baseColors.neutral20,
    buttonOutlinedTextDefault: baseColors.primary100,
    buttonOutlinedTextDisabled: baseColors.neutral40,
    // text / foreground
    text: baseColors.black,
    textSecondary: baseColors.neutral80,
    textTertiary: baseColors.neutral60,
    textBrand: baseColors.primary100,
    textInverted: baseColors.white,
    // charts
    CHART_PRIMARY: `hsl(254 29% 48%)`,
    CHART_SECONDARY: `hsl(11 100% 70%)`,
    CHART_TERTIARY: `hsl(177 73% 50%)`,
    CHART_4: `hsl(315 80% 74%)`,
    CHART_5: `hsl(31 100% 70%)`,
    CHART_6: `hsl(205 90% 57%)`,
    CHART_7: `hsl(292 73% 80%)`,
    CHART_8: `hsl(63 76% 47%)`,
    CHART_9: `hsl(204 84% 72%)`,
    CHART_10: `hsl(229 73% 80%)`,
    CHART_11: `hsl(38 100% 75%)`,
    CHART_12: `hsl(198 42% 49%)`,
    // CHART_PRIMARY: `oklch(51% 0.11 ${brandPrimaryHue})`,
    // CHART_SECONDARY: `oklch(74% 0.16 34)`,
    // CHART_TERTIARY: `oklch(81% 0.14 ${brandSecondaryHue})`,
    // CHART_4: `oklch(76% 0.16 337)`,
    // CHART_5: `oklch(83% 0.13 66)`,
    // CHART_6: `oklch(69% 0.16 245)`,
    // CHART_7: `oklch(81% 0.12 322)`,
    // CHART_8: `oklch(83% 0.18 113)`,
    // CHART_9: `oklch(79% 0.10 234)`,
    // CHART_10: `oklch(78% 0.09 274)`,
    // CHART_11: `oklch(88% 0.11 80)`,
    // CHART_12: `oklch(63% 0.09 229)`,
};
export default colors;
